import moment from 'moment-timezone';

import {DATE_ONLY_FORMAT, TWENTY_FOUR_HOUR_TIME_FORMAT} from '../config/DateTimeConstants';

export const MINUTES_PER_HOUR = 60;
const HOURS_DECIMAL_PLACES = 2;

export const formatDateAndTimeRange = (from, to, timezone) => {
    const start = moment.tz(from, timezone);
    const end = moment.tz(to, timezone);

    return {
        date: start.format(DATE_ONLY_FORMAT),
        time: `${start.format(TWENTY_FOUR_HOUR_TIME_FORMAT)} - ${end.format(TWENTY_FOUR_HOUR_TIME_FORMAT)}`,
    };
};

export const buildMonthDateRangeIso = (selectedMonth, timezone) => {
    const monthMoment = timezone
        ? moment(selectedMonth).tz(timezone)
        : moment(selectedMonth);

    return {
        startTime: monthMoment.clone().startOf('month').toISOString(),
        endTime: monthMoment.clone().endOf('month').toISOString(),
    };
};

export const formatMinutesAsHours = (totalMinutes) => {
    const totalHours = totalMinutes / MINUTES_PER_HOUR;
    const roundedHours = totalHours.toFixed(HOURS_DECIMAL_PLACES);

    return roundedHours;
};